import { render, staticRenderFns } from "./DigitalClinicsGeneric.vue?vue&type=template&id=3c0748ae"
import script from "./DigitalClinicsGeneric.vue?vue&type=script&lang=js"
export * from "./DigitalClinicsGeneric.vue?vue&type=script&lang=js"
import style0 from "./DigitalClinicsGeneric.vue?vue&type=style&index=0&id=3c0748ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports